(() => {
  const ALWAYS = "always_display";
  const HIDE_CLASS = "variant-hidden";
  const norm = (s) => (s || "").trim().toLowerCase();

  // --- Helpers ---
  function getSelectedColor(scope = document) {
    // Color is Option 1
    const radio =
      scope.querySelector('input[type="radio"][name*="option-1"]:checked') ||
      scope.querySelector('input[type="radio"][name*="option1"]:checked') ||
      scope.querySelector('input[type="radio"][name*="Color"]:checked') ||
      scope.querySelector('input[type="radio"][name*="options"]:checked');
    if (radio?.value) return radio.value.trim();

    const select =
      scope.querySelector('select[name*="option-1"]') ||
      scope.querySelector('select[name*="option1"]') ||
      scope.querySelector('select[name*="Color"]') ||
      scope.querySelector('select[name*="options"]');
    if (select?.value) return select.value.trim();

    const pressed =
      scope.querySelector('[data-option-position="1"][aria-pressed="true"]') ||
      scope.querySelector('[data-option-index="0"][aria-pressed="true"]') ||
      scope.querySelector('[role="radio"][aria-checked="true"]');
    if (pressed) {
      const v = pressed.getAttribute("data-value") || pressed.textContent;
      if (v) return v.trim();
    }

    return null;
  }

  function getAlt(el) {
    const img = el.querySelector("img");
    return img?.getAttribute("alt") || el.getAttribute("data-alt") || el.getAttribute("aria-label") || "";
  }

  function shouldShow(alt, color) {
    const a = norm(alt);
    const c = norm(color);

    if (!c) return true;
    if (!a) return true;                 // if no alt, keep visible (safe)
    if (a === norm(ALWAYS)) return true; // universal

    // Loose match so "Black 1" matches "Black"
    return a === c || a.startsWith(c) || a.includes(c);
  }

  function resetSliders(mg) {
    mg.querySelectorAll("slider-component").forEach((s) => {
      if (typeof s.resetPages === "function") s.resetPages();
    });
    const viewer = mg.querySelector('[id^="GalleryViewer"]');
    const thumbs = mg.querySelector('[id^="GalleryThumbnails"]');
    if (viewer && typeof viewer.resetPages === "function") viewer.resetPages();
    if (thumbs && typeof thumbs.resetPages === "function") thumbs.resetPages();
  }

  // IMPORTANT: this is the "fix blank main image" function.
  // It sets active media to the first visible media item *after filtering*.
  function forceActiveToFirstVisible(mg) {
    const mediaItems = Array.from(mg.querySelectorAll("[data-media-id]"))
      .filter((el) => !el.classList.contains(HIDE_CLASS));

    if (!mediaItems.length) return;

    const firstId = mediaItems[0].getAttribute("data-media-id");
    if (!firstId) return;

    if (typeof mg.setActiveMedia === "function") {
      mg.setActiveMedia(firstId, false);
      return;
    }

    const thumb = mg.querySelector(`[data-target="${CSS.escape(firstId)}"]`);
    const clickable = thumb?.querySelector("button,a") || thumb;
    if (clickable?.click) clickable.click();
  }

  function filterGallery(mg, color) {
    const mediaItems = mg.querySelectorAll("[data-media-id]");
    const thumbs = mg.querySelectorAll("[data-target]");

    // Main media filtering
    mediaItems.forEach((item) => {
      const alt = getAlt(item);
      item.classList.toggle(HIDE_CLASS, !shouldShow(alt, color));
    });

    // Thumbnail filtering (based on linked media)
    thumbs.forEach((thumb) => {
      const target = thumb.getAttribute("data-target");
      const linked = target ? mg.querySelector(`[data-media-id="${CSS.escape(target)}"]`) : null;
      const alt = linked ? getAlt(linked) : getAlt(thumb);
      thumb.classList.toggle(HIDE_CLASS, !shouldShow(alt, color));
    });

    resetSliders(mg);
  }

  function runFilterOnly() {
    const color = getSelectedColor(document);
    if (!color) return;
    document.querySelectorAll("media-gallery").forEach((mg) => filterGallery(mg, color));
  }

  // ✅ On refresh/load: filter, THEN force main image to a visible one (fixes “only thumbnails”)
  function runLoadFix() {
    const color = getSelectedColor(document);
    if (!color) return;

    document.querySelectorAll("media-gallery").forEach((mg) => {
      filterGallery(mg, color);
      forceActiveToFirstVisible(mg);
    });
  }

  // ----- Load passes (this is what fixes the refresh-on-black issue) -----
  document.addEventListener("DOMContentLoaded", () => {
    runLoadFix();
    setTimeout(runLoadFix, 250);
    setTimeout(runLoadFix, 700);
  });

  window.addEventListener("load", () => {
    runLoadFix();
    setTimeout(runLoadFix, 250);
  });

  // ----- On variant changes: ONLY filter (do NOT force active; avoids size resets) -----
  document.addEventListener("change", (e) => {
    if (e.target.closest(".product, variant-selects, variant-radios, form[action*='/cart/add']")) {
      setTimeout(runFilterOnly, 0);
      setTimeout(runFilterOnly, 150);
    }
  });

  // Watch variant id input too (theme updates this reliably)
  (function observeVariantId() {
    const idInput = document.querySelector('form[action*="/cart/add"] [name="id"]');
    if (!idInput) return;

    let last = idInput.value;
    setInterval(() => {
      if (idInput.value !== last) {
        last = idInput.value;
        setTimeout(runFilterOnly, 0);
        setTimeout(runFilterOnly, 150);
      }
    }, 250);
  })();
})();
